// Mock data for Les Façadiers HDF

export const companyInfo = {
  name: "Les Façadiers HDF",
  tagline: "Enduit / Plaquette / ITE",
  experience: "10+",
  zone: "Hauts-de-France",
  phone: "06.43.97.17.21",
  email: "facadiershdf@gmail.com",
  address: "Hauts-de-France",
  hours: "Lundi - Vendredi : 8h - 18h",
  gerant: "Nandar DILER"
};

export const services = [
  {
    id: 1,
    title: "Ravalement de façade",
    description: "Redonnez un coup de neuf à votre façade avec notre expertise en ravalement. Nous intervenons sur tous types de supports : pierre, brique, béton, enduit.",
    icon: "paintbrush",
    category: "Ravalement et rénovation",
    serviceImages: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/co4zlgkh_IMG_2965.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/f3noei6q_IMG_2966.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/6rbo6fil_IMG_2967.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/fqjjy0d3_IMG_2968.jpeg"
    ],
    benefits: [
      "Amélioration de l'esthétique",
      "Protection durable des murs",
      "Valorisation de votre bien",
      "Respect des normes locales"
    ]
  },
  {
    id: 2,
    title: "Isolation thermique par l'extérieur",
    description: "Réduisez vos factures d'énergie avec notre isolation thermique par l'extérieur (ITE). Une solution performante pour un confort optimal.",
    icon: "home",
    category: "Isolation et performance énergétique",
    serviceImages: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/jxl7qyyx_IMG_2763.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/vc8rm1rs_IMG_2762.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/pps7b9h8_885486d9-9270-44a6-932e-ca578c0bf195.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/49ot8uv9_a70a898b-e5ce-4b9f-b2a7-1a72a8304d16.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/tc9v6onv_371d09e2-91d0-456e-85f1-287de3517c64.jpeg"
    ],
    benefits: [
      "Économies d'énergie importantes",
      "Suppression des ponts thermiques",
      "Amélioration du confort intérieur",
      "Éligible aux aides financières"
    ]
  },
  {
    id: 3,
    title: "Pose à neuf de plaquettes / Rénovation de brique",
    description: "Pose de plaquettes de parement et rénovation complète de vos murs en briques. Nous redonnons vie à vos façades avec des techniques adaptées.",
    icon: "spray-can",
    category: "Ravalement et rénovation",
    serviceImages: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/qjsatt13_IMG_1346.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/t5394bu7_IMG_1347.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/8v8lt6m4_IMG_1348.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/zxlr0fx8_IMG_2727.jpeg"
    ],
    benefits: [
      "Pose de plaquettes décoratives",
      "Rénovation de briques anciennes",
      "Traitement et protection",
      "Finitions soignées"
    ]
  },
  {
    id: 4,
    title: "Peinture et enduits décoratifs",
    description: "Large choix de finitions et de couleurs pour personnaliser votre façade selon vos goûts et le style architectural.",
    icon: "palette",
    category: "Ravalement et rénovation",
    serviceImages: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/jvi0osc2_7e0b2168-f898-4923-9c12-b5a842eb6801.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/fzwgxmf6_IMG_6310.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/ijhyp1a6_59BE1CE2-50B2-4093-9C70-A4FA98A17523.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/so9fi8s2_IMG_6059.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/pv2goqbs_IMG_6060.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/h4796x2r_IMG_2998.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/gghor0q7_IMG_2997.jpeg"
    ],
    benefits: [
      "Large choix de teintes",
      "Finitions personnalisées",
      "Peintures haute qualité",
      "Rendu esthétique durable"
    ]
  },
  {
    id: 5,
    title: "Réparation et entretien",
    description: "Réparation des fissures, joints dégradés, et entretien régulier pour préserver l'intégrité de votre façade.",
    icon: "wrench",
    category: "Entretien et protection",
    detailedProcess: "Notre méthode professionnelle de réparation de fissures suit un protocole rigoureux : nous élargissons d'abord la fissure pour un traitement en profondeur, puis éliminons minutieusement toutes les poussières et résidus. Nous insérons ensuite une barre d'acier inoxydable de type Toxinox pour assurer la solidité structurelle. La fissure est alors comblée avec une mousse expansive ou un mortier classique selon les besoins spécifiques. Enfin, nous procédons au nettoyage du surplus et à l'application d'un enduit de finition pour un rendu impeccable et durable.",
    processImages: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/4sva1yst_IMG_2343.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/u6zinv1n_IMG_2351.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/q7ivq26o_IMG_2353.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/o19lyk2m_IMG_2355.jpeg"
    ],
    benefits: [
      "Traitement des fissures",
      "Réfection des joints",
      "Entretien préventif",
      "Garantie d'intervention rapide"
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "Plainville",
    location: "Plainville",
    type: "Enduit projeté sur des briques",
    category: "Ravalement de façade",
    images: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/haqzmnte_IMG_1071.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/deq840pk_IMG_1072.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/0c2aq9xf_IMG_1073.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/x2cn9why_IMG_1074.jpeg"
    ]
  },
  {
    id: 2,
    title: "Villers-Bretonneux",
    location: "Villers-Bretonneux",
    type: "Enduit projeté sur une extension de maison",
    category: "Ravalement de façade",
    images: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/s9tmj7os_IMG_2915.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/2gd5eu1z_IMG_2916.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/n9pa25px_IMG_2917.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/23n4assc_IMG_2918.jpeg"
    ]
  },
  {
    id: 3,
    title: "Rumigny",
    location: "Rumigny",
    type: "Pose à neuf de plaquettes / Rénovation de brique",
    category: "Pose à neuf de plaquettes / Rénovation de brique",
    images: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/t5394bu7_IMG_1347.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/zxlr0fx8_IMG_2727.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/a0ixvd10_IMG_2874.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/fup6iut0_IMG_2875.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/00rx90im_IMG_2876.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/9g4alzp0_IMG_2879.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/cru97sqj_IMG_2882.jpeg"
    ]
  },
  {
    id: 4,
    title: "Montdidier",
    location: "Montdidier",
    type: "Enduit projeté sur une façade collège Saint Vincent",
    category: "Ravalement de façade",
    images: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/9n6owqi7_IMG_2764.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/rp4mf1o6_IMG_2773.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/w8qqwzog_IMG_2811.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/d3hii1m8_IMG_2907.jpeg"
    ]
  },
  {
    id: 5,
    title: "Marle",
    location: "Marle",
    type: "Enduit projeté à la chaux",
    category: "Ravalement de façade",
    images: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/d5iv88ne_IMG_2269.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/egj3g02m_IMG_2270.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/32qhf8z0_IMG_2271.jpeg"
    ]
  },
  {
    id: 6,
    title: "Amiens",
    location: "Amiens",
    type: "Isolation par extérieur",
    category: "Isolation par extérieur",
    images: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/vvnvq4us_IMG_2273.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/qj851vu4_IMG_2274.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/q8viroeq_IMG_2320.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/gn9n15ev_IMG_2325.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/t5cxewc6_IMG_2328.jpeg"
    ]
  },
  {
    id: 7,
    title: "Etinehem",
    location: "Etinehem",
    type: "Isolation par extérieur en enduit RPE (Revêtement plastique épais)",
    category: "Isolation par extérieur",
    images: [
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/0zs6twu5_IMG_1429.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/acbpatli_IMG_1495.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/rdj0unpp_IMG_1497.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/6tkze1z1_IMG_1498.jpeg",
      "https://customer-assets.emergentagent.com/job_facade-artisan/artifacts/yfxmmqka_IMG_1606.jpeg"
    ]
  },
];

export const testimonials = [
  {
    id: 1,
    name: "N.H",
    rating: 5,
    source: "Google",
    text: "J'avais un chantier urgent et j'avais besoin d'un sous-traitant rapidement pour un ravalement de façade. Les Façadiers HDF ont répondu tout de suite, sont venus sur place rapidement et ont pris le chantier en main sans perdre de temps. Équipe sérieuse, efficace et très professionnelle. Le travail est propre et la communication a été simple du début à la fin. Je les recommande vivement si vous avez besoin d'un vrai pro rapidement."
  },
  {
    id: 2,
    name: "C.S",
    rating: 5,
    source: "Google",
    text: "Après un devis très détaillé et des conseils prodigués ne poussant pas à la dépense, les travaux ont été réalisés avec rapidité et soin. Je recommande fortement cette entreprise. Excellent contact avec le responsable commercial."
  },
  {
    id: 3,
    name: "J-L. F",
    rating: 5,
    source: "Google",
    text: "Entreprise sérieuse, travaux réalisés dans les délais. Je la recommande sans hésitation."
  },
  {
    id: 4,
    name: "A.K",
    rating: 5,
    source: "Travaux.com",
    text: "Excellent contact, personnes à l'écoute et très arrangeantes. Bon travail et rapidité."
  },
  {
    id: 5,
    name: "V.D",
    rating: 5,
    source: "Travaux.com",
    text: "Malgré des conditions météorologiques compliquées (canicule) l'équipe a assuré la bonne exécution de la prestation. Très bon relationnel avec les équipes terrains et avec le coordinateur Nathan. Un grand merci d'avoir sublimé ma maison. Je recommande."
  }
];

export const cities = [
  "Lille", "Amiens", "Roubaix", "Tourcoing", "Dunkerque",
  "Calais", "Valenciennes", "Douai", "Lens", "Arras",
  "Beauvais", "Compiègne", "Laon", "Saint-Quentin", "Maubeuge"
];

export const faq = [
  {
    id: 1,
    question: "Combien coûte un ravalement de façade ?",
    answer: "Le coût varie selon la surface, l'état de la façade et les travaux nécessaires. Nous proposons un devis gratuit et détaillé après visite sur site."
  },
  {
    id: 2,
    question: "Quelle est la durée des travaux ?",
    answer: "La durée dépend de la taille du chantier. En moyenne, comptez 2 à 4 semaines pour une maison individuelle. Nous vous informons du planning précis avant le début des travaux."
  },
  {
    id: 3,
    question: "Quelles aides financières sont disponibles ?",
    answer: "Pour l'isolation thermique par l'extérieur, vous pouvez bénéficier de MaPrimeRénov', des CEE et d'autres aides selon vos revenus. Nous vous accompagnons dans vos démarches."
  },
  {
    id: 4,
    question: "Intervenez-vous toute l'année ?",
    answer: "Oui, nous adaptons nos méthodes selon les conditions météorologiques. Certaines périodes sont plus favorables, nous vous conseillerons sur le meilleur moment pour votre projet."
  }
];